/**
 * Helpery itd. do wniosków/polis
 * współdzielone z aplikacjami mobilnymi!
 */
angular.module('ihestiaCommonDirectives.application', [
  'ihestiaRestServicesBase'
]);